import React from "react";
import { DragSource, DropTarget } from "react-dnd";
import ExternalLinks from "Widgets/ExternalLinks";
import { AppForIcon } from "../../CreaterForApp";
import { checkApp } from "../../utilService";
const cardSource = {
    beginDrag(props, monitor, component) {
        const { item } = props;
        return {
            id: item.cardid,
            index: props.index,
            cardList: [item],
        };
    },
};
const cardTarget = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        const dragIndex = dragItem.index;
        const hoverIndex = props.index;
        //从左侧拖过来
        if (dragItem.type === 'cardList') {
            props.addCardList(dragItem.cardList, hoverIndex);
        } else { //区域内排序
            if (dragIndex === hoverIndex) {return;}
            props.moveItem(dragIndex, hoverIndex);
        }
    },
};
class AppItem extends React.Component {
    render() {
        const { item, isDragging, isOver, connectDragSource, connectDropTarget } = this.props;
        const checkItem = checkApp(item);
        const style = isDragging ? { opacity: 0 } : {};
        return connectDragSource(
            connectDropTarget(
                <div style={style}>
                    {checkItem.isExternalLink ? (
                        // 外部链接
                        <ExternalLinks isDefaultStyle={false} id={item.cardid} editable={true} />
                    ) : (
                        <React.Fragment>
                            <div className="app-icon-container">
                                <div className="app-icon-content">
                                    <AppForIcon src={item.image_src} />
                                </div>
                            </div>
                            <div className="app-name">{item.name}</div>
                        </React.Fragment>
                    )}
                    {isOver && <div className="app-item-placeholder" />}
                </div>,
            ),
        );
    }
}
AppItem = DragSource("compactapp", cardSource, function (connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    };
})(AppItem);
AppItem = DropTarget(["compactapp", "item"], cardTarget, function (connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
    };
})(AppItem);
export default AppItem;
